<template>
  <div class="appcontent">
    <div class="ctycont">
      <div class="cty_bg">
        <div class="cty_title">
          <div>Sign up to the</div>
          <div>Transfomers</div>
          <div>Newsletter</div>
        </div>
        <div class="cty_con">We promise we won’t spam you.</div>
        <div class="ctyinpt">
          <input type="text" value="Enter your email" />
        </div>
        <div class="ctyinpt1">
          <input type="button" value="Subscribe now" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Index from "../Index.vue";
// import { Search } from "vant";
// const echarts = require("echarts");
// Vue.use(Search);
export default {
  components: {
    Index,
    // Search,
  },
  data() {
    return {
      searchValue: "",
      data: [],
      now: new Date(1997, 9, 3),
      oneDay: 24 * 3600 * 1000,
      series: {},
      num: 1,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style lang="less" scoped>
// -webkit-filter: blur(9px);
// filter: blur(9px);
.home {
  background: none !important;
}
.appcontent {
  width: 750px;
  margin: 0px auto 0px auto;
  background: #141414;
  text-align: center;
  .ctycont {
    background: #141414;
    height: 1200px;
    .cty_bg {
      padding-top: 273px;
      margin: 0 30px;
      display: flex;
      flex-direction: column;
      .cty_title {
        width: 690px;
        height: 336px;
        font-size: 96px;
        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 134px;
        text-align: left;
      }
      .cty_con {
        margin-top: 60px;

        height: 32px;
        font-size: 28px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 39px;
        text-align: left;
      }
      .ctyinpt {
        width: 690px;
        height: 100px;
        background: rgba(207, 97, 220, 0.10000000149011612);
        border-radius: 70px 70px 70px 70px;
        opacity: 1;
        border: 2px solid #cf61dc;
        margin: 64px 0 20px 0;
        input {
          border: none;
          height: 100px;
          line-height: 100px;
          font-size: 28px;
          font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
          font-weight: 400;
          color: #cf61dc;
          text-align: center;
        }
      }
      .ctyinpt1 {
        width: 690px;
        height: 80px;
        background: #cf61dc;
        border-radius: 70px 70px 70px 70px;
        opacity: 1;
        input {
          border: none;
          height: 80px;
          line-height: 80px;
          font-size: 28px;
          font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
         
        }
      }
    }
  }
}
</style>
